export const statusList = [
  {
    text: "Confirmed",
    value: "Confirmed",
  },
  {
    text: "Declined",
    value: "Declined",
  },
  {
    text: "Completed",
    value: "Completed",
  },
  {
    text: "Requested",
    value: "Requested",
  },
];
